import { MeterFrameConversionFactor, MeterConversionFactor } from '@app/api/nts';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';

export const meterframeConversionFactorTable: TableConfig<MeterFrameConversionFactor> = {
  columns: [
    {
      title: 'conversionFactorHistory.validFrom',
      key: 'validFrom',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
    {
      title: 'conversionFactorHistory.validTo',
      key: 'validTo',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
    {
      title: 'meterFrame.conversionFactors.A14',
      key: 'conversionFactorA14',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meterFrame.conversionFactors.A23',
      key: 'conversionFactorA23',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meterFrame.conversionFactors.R12',
      key: 'conversionFactorR12',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meterFrame.conversionFactors.R34',
      key: 'conversionFactorR34',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'conversionFactorHistory.createdBy',
      key: 'createdBy',
    },
    {
      title: 'conversionFactorHistory.created',
      key: 'created',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
  ],
};

export const meterConversionFactorTable: TableConfig<MeterConversionFactor> = {
  columns: [
    {
      title: 'conversionFactorHistory.validFrom',
      key: 'validFrom',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
    {
      title: 'conversionFactorHistory.validTo',
      key: 'validTo',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
    {
      title: 'meter.conversionFactors.A14',
      key: 'conversionFactorA14',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meter.conversionFactors.A23',
      key: 'conversionFactorA23',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meter.conversionFactors.R12',
      key: 'conversionFactorR12',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'meter.conversionFactors.R34',
      key: 'conversionFactorR34',
      cellRenderer: DecimalCellComponent,
      cellRendererParams: { decimals: 4 },
    },
    {
      title: 'conversionFactorHistory.createdBy',
      key: 'createdBy',
    },
    {
      title: 'conversionFactorHistory.created',
      key: 'created',
      cellRenderer: DateCellComponent,
      cellRendererParams: { format: DATE_TIME_FORMAT },
    },
  ],
};
